// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__HNyCk","list":"BalanceDue_list__2bc8P","listRow":"BalanceDue_listRow__2PB_G","total":"BalanceDue_total__8XILy"};